import { advancePayReducers } from "./advancePay.reducers";
import { authenticationReducers } from './authentication.reducers';
import { billOverviewReducers } from './billOverview.reducers';
import { debitNoteReducers } from "./debitNote.reducers";
import { invoicesReducers } from './invoices.reducers';
import { manualBillingReducers } from './manualBilling.reducers';
import { recursiveBillingSetupReducers } from './recursiveBillingSetup.reducers';
import { homeReducers } from './home.reducers';
import { profileReducers } from './profile.reducers';
import { reportReducers } from "./report.reducers";
import { userManagementReducers } from './userManagement.reducers';

import companyInfo from '../slices/companyInfo.slices';
import accountControl from '../slices/accountControl.slices';
import authentication from '../slices/authentication.slices';
import outlet from '../slices/outlet.slices';
import recursiveBillingSetup from "../slices/recursiveBillingSetup.slices";
import reporting from "../slices/reporting.slices";
import userManagement from "../slices/userManagement.slices";
import commitmentPaySetup from "../slices/commitmentPaySetup.slices";
import debitNoteV2 from "../slices/debitNoteV2.slices";
import mobileLicenseKey from "../slices/mobileLicenseKey.slices";

const rootReducer = {
    advancePayReducers,
    authenticationReducers,
    billOverviewReducers,
    debitNoteReducers,
    invoicesReducers,
    manualBillingReducers,
    recursiveBillingSetupReducers,
    homeReducers,
    profileReducers,
    reportReducers,
    userManagementReducers,
    
    companyInfo,
    accountControl,
    authentication,
    outlet,
    recursiveBillingSetup,
    reporting,
    userManagement,
    commitmentPaySetup,
    debitNoteV2,
    mobileLicenseKey
};

export default rootReducer;